import { PlayerAccountClient } from '../types'

/**
 * Account-restriction statuses (`checkResult.type` from user info).
 *
 * - `useGuard` fails safe on these: if the app forgot to configure one in `guards.statuses`,
 *   the user is redirected instead of silently reaching e.g. the deposit page.
 * - Player-feature queries (promotions, rewards, recent games) skip these accounts, because
 *   the backend refuses them with 403 or 200 `success:false`.
 */
export const ACCOUNT_RESTRICTION_STATUSES = new Set<string>([
    PlayerAccountClient.UserCheckResultType.deactivated,
    PlayerAccountClient.UserCheckResultType.block,
    PlayerAccountClient.UserCheckResultType.suspended,
    PlayerAccountClient.UserCheckResultType.suspended_missing_sof,
    PlayerAccountClient.UserCheckResultType.expired_block_must_be_removed_by_customer_service,
    PlayerAccountClient.UserCheckResultType.cooldown,
])

export const USER_INFO_KEY = 'playerAccount:userInfo'

export const USERNAME_KEY = 'nameservice:username'

export const CONTACT_VERIFICATION_STATUS_KEY = 'playerAccount:contactVerification:status'
